import { render } from "./StagesPane.vue?vue&type=template&id=0b34efef"
import script from "./StagesPane.vue?vue&type=script&lang=js"
export * from "./StagesPane.vue?vue&type=script&lang=js"

import "./StagesPane.vue?vue&type=style&index=0&id=0b34efef&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__